import styled from 'styled-components';

const ResultsWrapper = styled.div`
  color: #000;
  font-size: 15px;
  overflow: hidden;
  padding: ${({ isDesktop }) => (isDesktop ? '40px' : '10px')} 10px 0 15px;
  text-align: center;
  text-overflow: ellipsis;
  user-select: none;
  white-space: nowrap;
  width: 100%;
  font-family: 'Avenir Light', 'Arial', sans-serif;
`;

export default ResultsWrapper;
